// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_container__mx-db {
}

.modal_header__ZrtET {
    padding: 16px;
    border-bottom: rgba(51, 51, 51, 0.4) solid 1px;
    margin-bottom: 1rem;
}

.modal_noBorder__CzJt0 {
    border-bottom: none;
    margin-bottom: 0 !important;
}

.modal_header__ZrtET div:first-child {
    color: rgba(51, 51, 51, 80%);
    font-size: 20px;
}

.modal_body__MX-ja {
    padding-right: 16px;
    padding-left: 16px;
}

.modal_closeHeaderIcon__85FHS {
  flex-shrink: 0;
  cursor: pointer;
  outline: none !important;
  border: none;
  background: transparent;
  padding: 0.125rem;
  line-height: 1;
  border-radius: 6px;
}

.modal_closeHeaderIcon__85FHS:focus,
.modal_closeHeaderIcon__85FHS:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.modal_closeHeaderIcon__85FHS:active {
  opacity: 0.85;
}

.modal_footer__O9LYa {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0.65rem;
    padding: 0.85rem 0 1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/components/modal/modal.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,0BAA0B;AAC9B","sourcesContent":[".container {\n}\n\n.header {\n    padding: 16px;\n    border-bottom: rgba(51, 51, 51, 0.4) solid 1px;\n    margin-bottom: 1rem;\n}\n\n.noBorder {\n    border-bottom: none;\n    margin-bottom: 0 !important;\n}\n\n.header div:first-child {\n    color: rgba(51, 51, 51, 80%);\n    font-size: 20px;\n}\n\n.body {\n    padding-right: 16px;\n    padding-left: 16px;\n}\n\n.closeHeaderIcon {\n  flex-shrink: 0;\n  cursor: pointer;\n  outline: none !important;\n  border: none;\n  background: transparent;\n  padding: 0.125rem;\n  line-height: 1;\n  border-radius: 6px;\n}\n\n.closeHeaderIcon:focus,\n.closeHeaderIcon:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.closeHeaderIcon:active {\n  opacity: 0.85;\n}\n\n.footer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    gap: 0.65rem;\n    padding: 0.85rem 0 1.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `modal_container__mx-db`,
	"header": `modal_header__ZrtET`,
	"noBorder": `modal_noBorder__CzJt0`,
	"body": `modal_body__MX-ja`,
	"closeHeaderIcon": `modal_closeHeaderIcon__85FHS`,
	"footer": `modal_footer__O9LYa`
};
export default ___CSS_LOADER_EXPORT___;
